export interface VerificationResult extends VerificationResultBase {
  verified: boolean;
}

export interface VerificationResultBase {
  verificationRef: string;
}
